import { combineReducers } from 'redux';
import UnitHome from './UnitHome';
import CompanyCities from './CompanyCities';

export default combineReducers({
  UnitHome,
  CompanyCities,
});
